import { useState } from 'react'
import { Modal } from 'react-bootstrap'

import SafetyCaseForm from '../safety-case-page/safety-case-form'
import { Button, ISafetyCaseValues } from '../../../components'

type CreateSafetyCaseModalProps = {
  isOpen: boolean
  onClose: () => void
  onSubmit: (values: ISafetyCaseValues) => Promise<void>
  isSubmitting: boolean
  hasWriteAccess: boolean
}

const CreateSafetyCaseModal = (props: CreateSafetyCaseModalProps) => {
  const { isOpen, onClose, onSubmit, isSubmitting, hasWriteAccess } = props

  const [createFormApi, setCreateFormApi] = useState<any>()

  return (
    <Modal animation={false} onHide={onClose} show={isOpen} size="lg">
      <Modal.Header closeButton={true}>
        <Modal.Title>Create Safety Case</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <SafetyCaseForm
          onSubmit={onSubmit}
          formName="create-safety-case-form"
          baseStatus="Doing"
          setForm={setCreateFormApi}
          disabled={isSubmitting}
          isViewMode={!hasWriteAccess}
        />
      </Modal.Body>

      <Modal.Footer>
        <Button type="secondary" onClick={onClose} className="mr-2" disabled={isSubmitting}>
          Cancel
        </Button>

        <Button onClick={() => createFormApi?.submit()} disabled={isSubmitting || !hasWriteAccess}>
          Create
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default CreateSafetyCaseModal
